module.exports = function (Twig) {
    'use strict';

    Twig.Templates.registerParser('source', params => {
        return params.data || '';
    });
};



// WEBPACK FOOTER //
// ./node_modules/twig/src/twig.parser.source.js